<template>
    <v-form v-model="valid">
        <v-card-title class="px-0">
            <v-icon start color="primary">mdi-comment-text</v-icon>
            {{ $t('questions') }}
        </v-card-title>
        <div class="text-subtitle-2 text-primary mb-2">
            {{ $t('please_provide_answers') }}
        </div>
        <div v-for="(answerObj, i) in answersOnQuestions" :key="answerObj.id" class="d-flex flex-column">
            <span class="text-subtitle-2 text--secondary">
                {{ `${i + 1}.  ${getAnswerLabel(answerObj)}` }}
            </span>
            <v-text-field
                v-model="answerObj.answer"
                :placeholder="$t('type_here')"
                :rules="getAnswerRules(answerObj)"
            />
        </div>
    </v-form>
</template>

<script lang="ts">
    import {Component, Emit, mixins, Prop, VModel, Watch} from 'vue-facing-decorator'
    import {FormValidationRulesMixin} from '@/mixins/FormValidationRulesMixin.vue'

    @Component
    export class OrderDetailsQuestions extends mixins(FormValidationRulesMixin) {
        @VModel() valid
        @Prop({default: []}) additionalQuestions
        @Prop({default: false, type: Boolean}) isSavingWithoutDetails
        @Prop() processId

        answersOnQuestions = []

        @Emit()
        answersChanged() {
            return this.answersOnQuestions
        }

        @Watch('additionalQuestions', {deep: true, immediate: true})
        onAdditionalQuestionsChange() {
            this.answersOnQuestions =
                this.additionalQuestions?.map(q => ({
                    questionId: q.id,
                    answer: q.answer || '',
                    ...(this.processId && {processId: this.processId.replace(/^.{6}/, '')}),
                })) || []
        }

        @Watch('answersOnQuestions', {deep: true, immediate: true})
        onAnswersChange() {
            this.answersChanged()
        }

        getAnswerLabel(answerObj) {
            const question = this.additionalQuestions.find(q => q.id === answerObj.questionId)
            return question.questionText + (question.mandatory && !this.isSavingWithoutDetails ? '*' : '')
        }

        getAnswerRules(answerObj) {
            return this.additionalQuestions.find(q => q.id === answerObj.questionId).mandatory &&
                !this.isSavingWithoutDetails
                ? [this.requiredRule('')]
                : []
        }
    }

    export default OrderDetailsQuestions
</script>
